import { RouteObject } from "react-router-dom";

import { GeneralPublicRoutes } from "@src/routes/public/generalPublicRoutes";

export const PublicPageRoutes: RouteObject[] = [...GeneralPublicRoutes];
